import { useTranslation } from "react-i18next";
import { CiCircleCheck } from "react-icons/ci";
import React from "react";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";
import { useIsCoveredBooking } from "../common/hooks/useCoveredBooking";

const BookingSuccess = () => {
  const { t } = useTranslation();
  // A covered booking is CONFIRMED at this moment — there is no staff review
  // to wait for — so telling the member their request was received would be
  // wrong, and would send them to the front desk to ask (#1926).
  const isCovered = useIsCoveredBooking();

  return (
    <div className="flex flex-col w-full m-auto items-center justify-center h-[80%]">
      <CiCircleCheck className="size-[135px] text-primary" />
      <p className="text-[#515557] text-center mx-6 text-lg mt-6">
        {isCovered
          ? t("book_location.venue_reservation_overview.success_message_covered")
          : t("book_location.venue_reservation_overview.success_message")}
      </p>
      <SoftSignupPrompt />
    </div>
  );
};

export default BookingSuccess;
